import { api } from '../../api'
import TomSelectController, { type TomSelectOptions } from './tom-select'

type SubmissionSearchResult = {
  category: string
  created_at: string
  description: string
  id: string
  user_name: string
}

// A TomSelect that searches `/api/submissions` as the user types, instead of
// preloading options. It's its own controller because `load` and
// `render.option` are functions, which the JSON `data-tom-select-options`
// can't carry.
export default class RemoteSubmissionSearchController extends TomSelectController {
  declare excludeIdValue: string
  declare readonly hasExcludeIdValue: boolean

  static values = { excludeId: String }

  // Protected methods

  protected additionalOptions() {
    return {
      labelField: 'description',
      searchField: ['description', 'category', 'user_name'],
      valueField: 'id',
      load: (query: string, callback: (results?: SubmissionSearchResult[]) => void) => {
        api.submissions
          .search({ ids: this.#excludedIds(), query })
          .then(res => res.json)
          .then((json: SubmissionSearchResult[]) => callback(json))
          .catch(() => callback())
      },
      render: {
        option: (item: SubmissionSearchResult, escape: (value: string) => string) => `
          <div class="p-2">
            <div>
              ${escape(item.description)}
              <span class="text-xs text-gray-400 italic">by ${escape(item.user_name)}</span>
            </div>
            <p class="text-xs">
              Submitted <b class="text-whitelabel-400">${escape(item.created_at)}</b>
              in <b class="text-whitelabel-400">${escape(item.category)}</b>
            </p>
          </div>
        `,
      },
    } satisfies Partial<TomSelectOptions>
  }

  // Private methods

  // Skips the selected submissions and the record being edited
  #excludedIds() {
    const selected = this.element.tomselect?.items ?? []

    return this.hasExcludeIdValue ? [...selected, this.excludeIdValue] : selected
  }
}
